import React, { Component, memo, useState, useEffect, useImperativeHandle } from 'react'
import EmojiServices from '../../services/emoji.services'
import { ReactionItem, ReactionControlList } from './reaction-list'
import { useOnClickOutside } from '../../hooks/useOnClickOutside'
import { KeyDownEvent, eventKeyConstants } from '../../utils/eventKey'

const emojiServices = new EmojiServices()

const ReactionEmojiComp = React.forwardRef((props, ref) => {
  // const state = useSelector(state => state);
  // const dispatch = useDispatch();
  const searchParams = new URLSearchParams(window.location.search);
  const {
    wrapperClass = '',
    emojisData = {},
    hide_reaction_emoji = false, // show reaction emoji if already have reacted emojis
    show_reacted_emoji = true, // display the reacted emoji in next to reacted icon.
    params = [], // params that used to store the data in server
    icon_size = 18,
    updateReactedEmojis = null, // callback function is used to update the reacted emojis
    title = '',
    setKRHoverFocus = () => {},
    id_of_emoji = null
  } = props
  let reacted_emojis = props.reacted_emojis ? props.reacted_emojis : [];
  let emoji_id = props.id_of_emoji
  const { currentUser, emojis } = emojisData
  if (
    Array.isArray(reacted_emojis) &&
    reacted_emojis.length &&
    Array.isArray(emojis) &&
    emojis.length
  ) {
    reacted_emojis = reacted_emojis.map((r_obj) => {
      let concatName = emojis.find((e_obj) => r_obj.id === e_obj.id)
      r_obj.name = concatName ? concatName.name : ''
      return r_obj
    })
  }
  let reactedEmojis = reacted_emojis || []
  //const [reactedEmojis, setReactedEmojis] = useState(reacted_emojis || []);
  const [isOpen, setIsOpen] = useState(props.krRowEmojis)
  const [tooltip, setTooltip] = useState({})
  const reactedIconClass = [18, 24].includes(icon_size)
    ? `icon-reaction_${icon_size}px`
    : `icon-reaction_18px`

  const [isclicked, setIsclicked] = useState(false)
  const [wrapperRef] = useOnClickOutside(() => {
    setIsOpen(false)
    setKRHoverFocus(false);
  })

  useEffect(() => {
    if (Object.keys(tooltip).length === 0 && tooltip.constructor === Object) {
      let e1 = document.querySelector('.reaction-emoji-tooltip-wrapper')
      if (e1 != null) {
        e1.style.visibility = 'hidden'
        e1.innerHtml = ''
      }
    } else {
      let e1 = document.querySelector('.reaction-emoji-tooltip-wrapper')
      if (e1 != null) {
        const { e } = tooltip
        let ore = e.target
        if (!e.target.classList.contains('reacted-emoji-icon')) {
          console.log('inside parent node')
          if (e.target.parentNode) {
            ore = e.target.parentNode
            console.log('inside parent node 111')
          }
        }
        console.log(e.target)
        console.log('rect', e1.getBoundingClientRect())
        if (ore) {
          console.log('ore.offsetTop', ore.offsetTop)
          console.log('ore.offsetLeft', ore.offsetLeft)
          let { height = 0, width = 0 } = e1.getBoundingClientRect()
          let top = ore.offsetTop - height - 10
          let left = ore.offsetLeft - width / 2 + 25
          e1.style.top = `${top}px`
          e1.style.left = `${left}px`
          e1.style.visibility = 'visible'
        }
      }
    }
  }, [tooltip])

  useEffect(() => {
    $(`#${emoji_id}`).tooltip({
      position: {
        my: 'center top',
        at: 'center bottom+20',
        using: function(position, feedback) {
          $(this).css(position);
          $('<div>').addClass('tarrow').addClass(feedback.vertical)
            .addClass(feedback.horizontal).appendTo(this);
        }
      },
    });
  }, []);

  useEffect(() => {
    const isTabbing = document.body.classList.contains('is-tabbing');
    if (isTabbing) {
      setTimeout(() => {
        const el = `#reaction-combined-shape #${emoji_id}`
        const focusEl = $(el)
        if (focusEl) focusEl.focus()
        document.body.classList.add('is-tabbing');
      })
    }
  })

  useImperativeHandle(
    ref,
    () => ({
      toggleReaction() {
        toggleReactionEmojis('onLeave')
        setKRHoverFocus(false)
      }
    }),
)
  const reducerCount = (accumulator, currentValue) =>
    accumulator + parseInt(currentValue.count)

  /**
   * open the reaction control list if click on reaction icon.
   */
  const toggleReactionEmojis = (val) => {
    if (val == 'click') {
      setIsOpen(!isOpen)
      setKRHoverFocus(true)
    } else if (val == 'onHover' || val == 'onKeyPress') {
      setIsOpen(true)
      setKRHoverFocus(true)
    } else if (val == 'onLeave' || val.key === 'Escape') {
      setIsOpen(false)
      setIsclicked(false)
      setKRHoverFocus(false)
    }
    if (val.key !== 'Escape') {
      const isTabbing = document.body.classList.contains('is-tabbing');
      if(isTabbing) {
        setTimeout(() => {
          const reactionEmojiIcon = document.getElementsByClassName(
            'reaction-emoji-icon'
          )[0]
          if (reactionEmojiIcon) reactionEmojiIcon.focus()
          document.body.classList.add('is-tabbing');
        }, 100)
      }
    }
  }

  /**
   * add reaction
   * @param {*} emoji
   */
  const addReactionItem = (emoji) => {
    window.wb_track('OKR_ACTION', {
      location: searchParams.get('location') || '',
      locationDetail: searchParams.get('locationDetail') || '',
      object: 'KEY_RESULT',
      objectId: props.params?.metricId || '',
      objectAction: 'REACT',
    });
    const findEmoji = reactedEmojis.find((e) => e.id == emoji.id)
    let actionType = 'add'
    if (findEmoji) {
      reactedEmojis.map((e) => {
        if (e.id == emoji.id) {
          const findUser = e.users.find((u) => u.id == currentUser.id)
          if (!findUser) {
            e.users = [...e.users, currentUser]
            e.count = parseInt(e.count) + 1
          } else {
            e.users = e.users.filter((u) => u.id != currentUser.id)
            e.count = e.users.length
            actionType = 'remove'
          }
        }
      })
      setIsclicked(false)
    } else {
      const newEmoji = Object.assign({}, emoji, {
        count: 1,
        users: [currentUser],
      })
      reactedEmojis = reactedEmojis.concat(newEmoji)
      setIsclicked(false)
    }

    updateReactionEmojisData(
      emoji,
      {
        reactedEmojis,
        isOpen: false,
      },
      actionType
    )
    setKRHoverFocus(false)
  }

  /**
   * removed the reacted emoji if already reacted.
   * @param {object} emoji
   */
  const removedReactedEmojiCount = (emoji) => {
    const findEmoji = reactedEmojis.find((e) => e.id == emoji.id)
    //  let indexToBeRemoved;
    //   const findEmoji = reactedEmojis.find((e, index) => {
    //     if(e.id == emoji.id){
    //       indexToBeRemoved = index;
    //       return true;
    //     }
    //   });
    if (findEmoji) {
      reactedEmojis.map((e) => {
        if (e.id == emoji.id) {
          e.users = e.users.filter((u) => u.id != currentUser.id)
          e.count = e.users.length
        }
      })
      setIsclicked(false)
    }
    // reactedEmojis.splice(indexToBeRemoved, 1);
    updateReactionEmojisData(
      emoji,
      {
        reactedEmojis,
      },
      'remove'
    )
  }

  const addOrRemoveReactionItem = (emoji, action = '', click= false, count = true) => {
    if (action == 'add') {
      addReactionItem(emoji)
    } else if (action == 'remove') {
      window.wb_track('OKR_ACTION', {
        location: searchParams.get('location') || '',
        locationDetail: searchParams.get('locationDetail') || '',
        object: 'KEY_RESULT',
        objectId: props.params?.metricId || '',
        objectAction: 'REACT',
      });
      removedReactedEmojiCount(emoji)
    }

    if (props.id_of_emoji && click) {
      setTimeout(() => {
        document.getElementById(props.id_of_emoji) && count &&
          document.getElementById(props.id_of_emoji).focus()
      }, 10)
    }
  }

  /**
   * trigger callback method to update reacted emojis
   */
  const triggerCallbackMethod = (values) => {
    if (typeof props.updateReactedEmojis === 'function') {
      const propsParams = props.params
      props.updateReactedEmojis({
        ...propsParams,
        reacted_emojis: values,
      })
    }
  }

  const updateReactionEmojisData = (emoji, stateObj, action = 'add') => {
    let passParams = params
    if (typeof params.notificationData !== 'undefined') {
      // remove notificationData from params
      const { notificationData, ...NonotificationData } = params
      passParams = NonotificationData
    }
    passParams.emoji_id = emoji.id
    if (action == 'add') {
      emojiServices.addReactedEmoji(passParams)
    } else if (action == 'remove') {
      emojiServices.removeReactedEmoji(passParams)
    }
    if (Object.keys(stateObj).includes('reactedEmojis')) {
      //setReactedEmojis(stateObj.reactedEmojis);
      triggerCallbackMethod(stateObj.reactedEmojis)
    }
    if (Object.keys(stateObj).includes('isOpen')) {
      setIsOpen(stateObj.isOpen)
    }
  }

  const showToolTip = () => {
    let { item = {}, e } = tooltip
    if (
      Object.keys(item).length &&
      typeof item.users !== 'undefined' &&
      item.users.length
    ) {
      console.log('ousee', e)
      let users = item.users.map((u) => u.name).join(' ')
      let tooltipCss = {}
      tooltipCss.top = 0
      tooltipCss.left = 0
      tooltipCss.visibility = 'hidden'
      users = `react tooltip, example codepen, test asdf adsf, adf adsf, asdf adsf,asd fdsf s, react tooltip, example codepen, test asdf adsf, adf adsf, asdf adsf,asd fdsf s, pandi kamal test asdf adsf, adf adsf, asdf adsf,asd fdsf s, pandi kamal`
      return (
        <div className="reaction-emoji-tooltip-wrapper" style={tooltipCss}>
          <div className="reaction-emoji-tooltip-content">{users}</div>
        </div>
      )
    } else {
      return null
    }
  }

  const showEmoji = (e) => {
    e.stopPropagation()
    toggleReactionEmojis('onKeyPress')
  }

  const emojiIconKeyHandler = (e) => {
    if (e.key === eventKeyConstants.ESCAPE) {
      e.preventDefault()

      if (props.changeShowEmojiHoverState) {
        props.changeShowEmojiHoverState(false)
        document.getElementById(props.emojiFocusId).focus()
      }
    } else if (e.shiftKey && e.key === eventKeyConstants.TAB) {
      if (props.changeShowEmojiHoverState) {
        e.preventDefault()

        const reactedEmojiWrapper = document.querySelector(
          '#reacted-emoji-wrapper'
        )
        const reactedEmojiWrapperLength = reactedEmojiWrapper.children.length
        reactedEmojiWrapper.children[
          reactedEmojiWrapperLength - 1
        ].children[0].focus()
      }
    } else {
      KeyDownEvent(e, () => showEmoji(e))
    }
  }
  /**
   * call render lifecycle
   */

  if (hide_reaction_emoji) {
    const count = reactedEmojis.reduce(reducerCount, 0)
    if (count == 0) {
      return null
    }
  }

  return ((!props.isReadOnlyEnabled || (props.isReadOnlyEnabled && reactedEmojis.length > 0)) && (
    <div className={'reaction-comp-wrapper ' + wrapperClass}>
      <div
        className="reaction-react-icon"
        style={{
          margin: props.showReaction ? '10px 0 0 0' : '',
          marginTop: props.krRowEmojis ? '-19px' : '',
          width: props.krRowEmojis ? '35px' : '',
        }}
        onMouseOver={
          props.krRowEmojis
            ? () => toggleReactionEmojis('onHover')
            : () => {
                return
              }
        }
        //    onMouseLeave={props.krRowEmojis ? () => toggleReactionEmojis('onLeave') : ''}
      >
        {!props.isReadOnlyEnabled && (<div
          role="button"
          aria-label="Add a reaction"
          title={title}
          aria-controls={isclicked ? 'reaction-combined-shape' : null}
          aria-owns={isclicked ? 'reaction-combined-shape' : null}
          aria-haspopup="true"
          tabIndex={0}
          // className= {`emoji-icon-btn-gbl `+reactedIconClass}
          className={'icon ' + reactedIconClass + ` emoji-icon-btn`}
          id={props.krRowEmojis ? null : emoji_id}
          onClick={() => {
            toggleReactionEmojis('click')
            setIsclicked(true)
          }}
          onKeyDown={(e) => {
            emojiIconKeyHandler(e)
            setIsclicked(true)
          }}
          // onMouseOver={props.showReaction ? () => toggleReactionEmojis('onHover') : () => { return }}
          //    onMouseLeave={() => toggleReactionEmojis('onLeave')}
          style={{
            display: props.krRowEmojis ? 'none' : '',
          }}
        ></div>)}
        <span ref={wrapperRef} className="reaction-emojis-container">
          {isOpen ? (
            <ReactionControlList
              key="memozied_reaction_control"
              emojis={emojisData.emojis}
              addReactionItem={addReactionItem}
              toggleReactionEmojis={toggleReactionEmojis}
              krRowEmojis={props.krRowEmojis}
              metric={props.metric}
              goalId={props.goalId}
              emojisData={emojisData}
              showReactedEmoji={props.showReactedEmoji}
              addOrRemoveReactionItem={addOrRemoveReactionItem}
              currentUser={currentUser}
              reacted_emojis={reactedEmojis}
              krHoverFlag={props.krHoverFlag}
              parentMetricId={props.params.parent_metric_id}
              emoji_id={emoji_id}
              changeShowEmojiHoverState={props.changeShowEmojiHoverState}
              emojiFocusId={props.emojiFocusId}
              setKRHoverFocus={setKRHoverFocus}
              id_of_emoji={id_of_emoji}
            />
          ) : (
            ''
          )}
        </span>
      </div>
      {show_reacted_emoji && !props.krRowEmojis ? (
        <div
          className="reacted-emoji-wrapper"
          aria-atomic="true"
          aria-live="polite"
        >
          {reactedEmojis.map((emoji, index) => (
            <ReactionItem
              key={'memozied_react_' + index}
              emoji={emoji}
              addOrRemoveReactionItem={addOrRemoveReactionItem}
              currentUser={currentUser}
              emoji_id={emoji_id}
              emojiFocusId={props.emojiFocusId}
            />
          ))}
        </div>
      ) : (
        ''
      )}
      <div className="clear"></div>
    </div>
  ))
})

export default memo(ReactionEmojiComp)
